import { Routes } from '@angular/router';
import { OverviewComponent } from './features/overview/overview.component';
import { PersonalAccessTokenComponent } from './features/personal-access-token/personal-access-token.component';
import { SepaDetailComponent } from './features/detail/sepa-detail/sepa-detail.component';
import { CompletedComponent } from './features/completed/completed.component';
import { VerificationErrorComponent } from './errors/verification-error/verification-error.component';
import { AlreadySentComponent } from './errors/already-sent/already-sent.component';
import { CheckForTokenGuard } from './shared/guards/token-guard';
import { LandingpageConfigurationStateService } from './shared/services/state/landingpage-configuration-state.service';

export const routes: Routes = [
  {
    path: '',
    component: PersonalAccessTokenComponent,
  },
  {
    path: 'case',
    component: OverviewComponent,
    resolve: {
      landingPageConfiguration: LandingpageConfigurationStateService,
    },
  },
  {
    path: 'sepa',
    component: SepaDetailComponent,
    resolve: {
      landingPageConfiguration: LandingpageConfigurationStateService,
    },
  },
  {
    path: 'completed',
    component: CompletedComponent,
    resolve: {
      landingPageConfiguration: LandingpageConfigurationStateService,
    },
  },
  {
    path: 'already-sent',
    component: AlreadySentComponent,
  },
  {
    path: 'verification-error',
    component: VerificationErrorComponent,
  },
  {
    path: 'verify',
    canActivate: [CheckForTokenGuard],
    component: PersonalAccessTokenComponent,
  },
];
